import {RemoteGetHealthProviderLocationPreview} from 'data/usecases/private/booking-flow/health/remote-get-health-provider-location-preview';
import {GetHealthProviderLocationPreview} from 'domain/usecases/private/booking-flow/health/get-health-provider-location-preview';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {makeBFFApiUrl} from 'main/factories/http';
import {BookingFlowEndPoints} from 'main/factories/usecases/endpoints';

export const makeGetHealthProviderLocationPreview = (): GetHealthProviderLocationPreview =>
	new RemoteGetHealthProviderLocationPreview(
		makeBFFApiUrl(BookingFlowEndPoints.healthProviderLocationPreview),
		makeAuthorizeHttpClientDecorator(),
	);
